export default __webpack_public_path__ + "static/media/Aptos-Semibold.377e178e.ttf";